import { DataTableFilter } from '@/types/DataTable'
import { computed, Ref, ref } from 'vue'

interface SelectFilterPayload {
  label: string
  field: string
  icon: string
  items: { title: string, value: string }[]
  required: boolean
  initial?: string | null
  clearable?: boolean
}

export function useSelectFilter({
  label,
  field,
  icon,
  items,
  required,
  initial = null,
  clearable,
}: SelectFilterPayload): DataTableFilter<string> {
  const loading = ref(false)

  const model: Ref<string | null> = ref(initial)

  const ready = Promise.resolve(true)

  return {
    model,
    value: computed(() => model.value),
    items: computed(() => items),
    label,
    field,
    icon,
    type: 'select',
    loading,
    ready,
    required,
    clearable,
  }
}
